import React from 'react';

import './view-all-row.scss';

const ViewAllRow = ({type, setviewAll, viewAll, numEntries, table}) => {

    return (
        <>
            <tr className='view-all-rows'>
                {
                    (table.toLowerCase().includes('project') || table.toLowerCase().includes('task'))
                    && <> <td className="flex-grow-1"></td></>
                    
                }
                <td className='view-all-results'>
                    Showing {viewAll ? numEntries : (numEntries > 10 ? 10 : numEntries)} of {numEntries}
                </td>
                { 
                    // Only allow expansion of the group if there are more than 10 entries
                    <td className="view-all-rows-button-container">
                        <button className='view-all-rows-button' 
                                onClick={() => setviewAll({type: `viewAll_${type}`, payload: !viewAll, action: 'toggle'})}
                                disabled={numEntries <= 10 ? true : false}
                        >
                            {viewAll? 'Minimize' : 'View All'}
                        </button>
                    </td>
                }
                
            </tr>
        </>
    )
}

export default ViewAllRow;
